module.exports = "//staticcdn.igetget.com/docker/fe-iget-official/dist/img/gzh.c221e3d.png";


//////////////////
// WEBPACK FOOTER
// ./client/www/assets/gzh.png
// module id = 37
// module chunks = 8